import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { GenericEdit } from 'src/app/interfaces/generic-edit';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';


export interface ViaVarejoAttribute{
  levelId?:string;
	udaGroupId?:string;
	udaGroupName?:number;
	mpUda:mpUda[];
}

export interface mpUda{  
  udaId:string;
  udaName:string;
  isRequired:string;
  isVariant:string;
  udaValues:udaValues[];
  datavalue:string;
}

export interface udaValues{
    udaValue:string;
    udaValueId:string;
}

@Component({
    selector: 'app-viavarejo-attribute',
    templateUrl: './viavarejo-attribute.component.html',
    styleUrls: ['./viavarejo-attribute.component.scss'],
    standalone: false
})
export class ViaVarejoAttributeComponent implements OnInit {

  @Output() saving:EventEmitter<boolean> = new EventEmitter();
  attribValidator:AbstractControl[] = [];
  attribs:ViaVarejoAttribute[] = [];
  buttonList:ButtonList[] = [];
  product:Object;
  data:GenericEdit = null;
  row:Object = [];
  codeproduct = 100007;
  codecompany = 155;
  codecontract = 28;
  codcategoria =  57;
  codeproductvar=100007;
  sub1:Subscription;
  sub:Subscription;
  codeviavarejo = 1;

  constructor(private http:HTTPService, private uid:UserAuthenticationServices, private cd:ChangeDetectorRef, private spinner:NgxSpinnerService,
    private snackBar:SnackbarService) { }

  ngOnInit(): void {

    if ( this.data != null){  
      
      this.row = this.data.row;

      this.codecompany = this.data['parentRow']['linha']['CODECOMPANY'];
      this.codeproduct = this.data['parentRow']['linha']['CODEPRODUCT'];
      this.codeproductvar = this.data['parentRow']['linha']['CODEPRODUCTVAR'];
      this.codecontract = this.data['parentRow']['linha']['CODECONTRACT'];
      this.codeviavarejo = this.data['parentRow']['linha']['CODEVIAVAREJO'];

      
    }

    this.buttonList.push({
      color:"primary",
      description:"Salvar",
      action: ()=>{
          this.okFunction();
      }
    },
    {
      color:"warn",
      description:"Cancelar",
      action: ()=>{
          this.cancelFunction();
      }
    })


    this.initialize().finally(()=>{this.spinner.hide()});
    
  }

  initialize(){
    
    this.spinner.show();
    return new Promise(async (resolve,reject)=>{
      
      let ob = {
        "entityName":"Mktpactivecompanies",
        "sql":`SELECT A.ACESSTOKEN,A.CLIENTID
              FROM MKTPACTIVECOMPANIES A INNER JOIN MKTPCOMPANIES B ON A.CODECOMPANY=B.CODECOMPANY
              WHERE A.CODECOMPANY=${this.codecompany}
              AND A.CODEMKTP=32
              AND A.STATUS=1
              AND A.ENVIRONMENT=1`
      }
       
      this.sub1 = this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
           
          if( ObjectUtil.isNotEmpty(con['SQL'])){
    
            let clientid:string  = con['SQL'][0]['CLIENTID'];
            let acesstoken:string  = con['SQL'][0]['ACESSTOKEN'];
            
        
            this.getAttributeData().then((atributos:Object[])=>{
              this.findAtributes(clientid,acesstoken,atributos);
            })
            
          }
        });
    
        resolve(true);
    });
    
  }

  isRequired(item:mpUda){
    if ( item.isRequired =='S'){
      return true;
    }else{
      return false;
    }
    
  }

  isVariant(item:mpUda){
    if ( item.isVariant =='S'){
      return true;
    }else{
      return false;
    }
    
  }

  deleteItem(item:ViaVarejoAttribute){
      //let index = this.attribs.findIndex(i=>i.attribute_id == item.attribute_id);
      //this.attribs.splice(index,1);
  } 

  openDataOption(item:ViaVarejoAttribute){
    throw ("Não implementado");
  }

 

  okFunction(){
    this.salvar(); 
  }

  cancelFunction(){
    this.saving.next(false);
  }
  


findAtributes(clientId,acesstoken, atributos:Object[]){

    let ob = {
      "expressao": "getRequestData(GetAtributos,Product4,?id="+this.codcategoria+",GET,null,{@HEADER},{@CODEMKTP})",
      "novo": true,
      "codecompany": this.codecompany,
      "codemktp": 32,
      "codecontract": 0,
      "values":[] 
    }

    let header = {
      key:'@HEADER',
      value:`client_id:${clientId};access_token:${acesstoken}`
    }
    
    ob['values'].push(header);

    this.sub = this.http.post(ob,'FormulaServices/test', true,true,false).subscribe(data=>{
        this.transformData(data);
        if ( atributos ){
          for ( var a of atributos){
            try{
              this.attribs.find(d=>d.udaGroupId == a['UDAGROUPID']).mpUda.find(x=>x.udaId==a['UDAID']).datavalue = a['DATAVALUE'];
            }catch(ignored){}
          }
        }
        this.cd.markForCheck();
    },error=>{
        this.spinner.hide();
        throw error;
    },()=>{
        this.spinner.hide();
    })

}

transformData(data){
    if ( data['resultado']){
      this.attribs = JSON.parse(data['resultado']);    
    }
    
}
  
  prepareData():Object[]{
      let dataObject:Object[] = [];
       
      for ( var data of this.attribs ){
          let ob = {};
          
          ob['UDAGROUPID'] = data.udaGroupId;
          ob['UDAGROUPNAME'] = data.udaGroupName;
          ob['LEVELID'] = data.levelId;

          data.mpUda.forEach(d=>{

            let obDetail = {};
            obDetail['DATAVALUE'] = d.datavalue;
            obDetail['ISREQUIRED'] = d.isRequired;
            obDetail['ISVARIANT'] = d.isVariant;
            obDetail['UDAID'] = d.udaId;
            obDetail['UDANAME'] = d.udaName;
            obDetail['UDAVALUES'] = JSON.stringify(d.udaValues);

            obDetail['CODECOMPANY'] = this.codecompany;
            obDetail['CODECONTRACT'] = this.codecontract;
            obDetail['CODEPRODUCT'] = this.codeproduct;
            obDetail['CODEPRODUCTVAR'] = this.codeproductvar;
            obDetail['CODEVIAVAREJO'] = this.codeviavarejo;
            
            let newOb = {...ob, ...obDetail};

            dataObject.push(newOb);
          });
      }

      return dataObject;
  }

  salvar(){
    this.spinner.show();
    
    let local = {
      entityName: 'Mktpviavarejoatributos',
      remove:true,
      removeCondition: `codecompany=${this.codecompany} and codeproduct=${this.codeproduct} and codeproductvar = ${this.codeproductvar}`,
      data: this.prepareData()
    }

    this.http.post(local,'JsonBrokerServices/save',false,true,true).subscribe(result=>{
        this.snackBar.showSuccess("Atributos importados com sucesso.");
        this.saving.next(true);
        this.spinner.hide(); 
    },(error)=>{
        this.spinner.hide();
        throw error;
    });
  }


  async getAttributeData(){

    return await new Promise((resolve,reject)=>{
      
      let ob = {
        "entityName":"Mktpviavarejo",
        "sql":`SELECT B.CODCATEGORIA, A.*
              FROM Mktpviavarejo B LEFT OUTER JOIN Mktpviavarejoatributos A  ON A.CODECOMPANY=B.CODECOMPANY
                                                        AND A.CODEPRODUCT=B.CODEPRODUCT
                                                        AND A.CODECONTRACT=B.CODECONTRACT
                                                        AND A.CODEPRODUCTVAR=${this.codeproductvar}
                                                        
              WHERE B.CODECOMPANY=${this.codecompany}
              AND B.CODEPRODUCT=${this.codeproduct}`
      }
       
      this.sub1 = this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
        if ( con['SQL'] ){
          this.codcategoria = con['SQL'][0]['CODCATEGORIA'];

          if ( !ObjectUtil.isNotEmpty(this.codcategoria) ){
            throw Error('Não informado o código da categoria no produto.');
          }
          resolve(con['SQL'] as Object[]);
        }
        
      },(error)=>{
          throw error;
      });
    })
  }
}
